import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../config/auth-context';
import DashboardHeader from './dashboard-header';
import DashboardSidebarLeft from './dashboard-sidebar-left';

const DashboardLayout: React.FC = () => {
	const { userRoles } = useAuth();
	const [sidebarOpen, setSidebarOpen] = useState(false);

	const allowedRolesForSidebarAndHeader = [
		'User-Employee',
		'User-Marketing',
		'User-Agent-Assist',
		'Administrator',
		'User-Conversational-AI',
	];

	const hasAccessToSidebarAndHeader = allowedRolesForSidebarAndHeader.some((role) => userRoles.includes(role));

	const handleSidebarToggle = () => {
		setSidebarOpen(!sidebarOpen);
	};

	return (
		<div className="flex h-full">
			{hasAccessToSidebarAndHeader && (
				<DashboardSidebarLeft sidebarOpen={sidebarOpen} onSidebarToggle={handleSidebarToggle} />
			)}
			<div className={hasAccessToSidebarAndHeader ? 'flex-1 lg:pl-72' : 'flex-1'}>
				{hasAccessToSidebarAndHeader && <DashboardHeader onSidebarToggle={handleSidebarToggle} />}

				{/* Main content */}
				<main>
					<Outlet />
				</main>
			</div>
		</div>
	);
};

export default DashboardLayout;
